import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiPackage, FiServer, FiGlobe } from 'react-icons/fi';
import api from '../services/api';
import './NavbarSiteMonitor.css';

const PROBES = [
  { key: 'home', Icon: FiHome, short: 'Home' },
  { key: 'pdp', Icon: FiPackage, short: 'PDP' },
  { key: 'woo_api', Icon: FiServer, short: 'API' },
];

function probeTitle(probe, row) {
  const names = { home: 'Homepage', pdp: 'Productpagina', woo_api: 'Woo REST' };
  const name = names[probe] || probe;
  if (!row) return `${name}: nog geen meting`;
  const ms = row.ttfb_ms != null ? `${row.ttfb_ms} ms TTFB` : '—';
  const st =
    row.level === 'ok'
      ? 'OK'
      : row.level === 'warn'
        ? 'Traag'
        : row.level === 'crit'
          ? 'Zeer traag'
          : row.level === 'down'
            ? 'Probleem'
            : 'Onbekend';
  return `${name}: ${ms} (${st})`;
}

function levelClass(level) {
  if (level === 'ok') return 'ok';
  if (level === 'warn') return 'warn';
  if (level === 'crit' || level === 'down') return 'bad';
  return 'unknown';
}

export default function NavbarSiteMonitor() {
  const [summary, setSummary] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/site-monitor/summary');
      setSummary(res.data);
    } catch {
      setSummary(null);
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 2 * 60 * 1000);
    return () => clearInterval(t);
  }, [refresh]);

  const probes = summary?.probes || [];
  const byKey = Object.fromEntries(probes.map((p) => [p.probe, p]));
  const overall = summary?.overall || 'unknown';

  return (
    <Link
      to="/koppelingen?tab=shop_monitor"
      className={`navbar-site-monitor overall-${levelClass(overall)}`}
      title="4shine.nl snelheid — klik voor details en grafiek"
    >
      <span className="navbar-site-monitor-label">
        <FiGlobe aria-hidden />
        <span className="navbar-site-monitor-label-text">4shine</span>
      </span>
      <span className="navbar-site-monitor-icons">
        {PROBES.map(({ key, Icon, short }) => {
          const row = byKey[key];
          const lvl = row?.level || 'unknown';
          return (
            <span
              key={key}
              className={`navbar-site-monitor-pill level-${levelClass(lvl)}`}
              title={probeTitle(key, row)}
            >
              <Icon aria-hidden />
              <span className="navbar-site-monitor-ms">
                {row?.ttfb_ms != null ? `${Math.round(row.ttfb_ms / 100) / 10}s` : '—'}
              </span>
              <span className="navbar-site-monitor-short">{short}</span>
            </span>
          );
        })}
      </span>
    </Link>
  );
}
